import script from "./ViewFireExtinguisher.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFireExtinguisher.vue?vue&type=script&setup=true&lang=js"

import "./ViewFireExtinguisher.vue?vue&type=style&index=0&id=28aab790&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28aab790"]])

export default __exports__